// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EtQqM","toggleWrap":"styles_toggleWrap__1UysM","content":"styles_content__1BaVU","selectAreaCode":"styles_selectAreaCode__2sMpg"};